import { useDelay } from 'hooks/useDelay';
import { TEInput } from '@timeedit/ui-components';
import { Skeleton, Tree, type TreeProps } from '@timeedit/ui-components/antd';
import './index.scss';

type TTreeComponent = TreeProps & {
  title?: string;
  handleSearch?: (text: string) => void;
};

const TreeComponent = ({
  title = '',
  selectedKeys = [],
  defaultExpandAll = true,
  handleSearch,
  ...treeProps
}: TTreeComponent) => {
  const delay = useDelay(0.5);
  return (
    <div
      className="tree-container"
      style={{ zIndex: 1000000 }}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      {title ? <p>{title}</p> : null}
      <div className="tree-content">
        {delay ? (
          <Skeleton />
        ) : (
          <div
            onClick={(e) => {
              e.stopPropagation();
              e.nativeEvent.stopImmediatePropagation();
            }}
          >
            {handleSearch ? (
              <TEInput.Input
                style={{ marginBottom: 8 }}
                placeholder="Search"
                onChange={handleSearch}
              />
            ) : null}
            <Tree
              defaultExpandAll={defaultExpandAll}
              selectedKeys={selectedKeys}
              {...treeProps}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TreeComponent;
